// extracted by mini-css-extract-plugin
export default {"main":"Home_main__jjcCn","bgPic":"Home_bgPic__14OzV"};